import 'slick-carousel';

export function initSlickCarousel() {
  $('.avis-block').slick({
    autoplaySpeed: 5000,
    autoplay: true,
    infinite: true,
    fade: false,
    arrow: true,
    speed: 1500,
    dots: true,
  });
  $('.header-slider').slick({
    lazyLoad: 'progressive',
    autoplaySpeed: 10000,
    mobileFirst: true,
    infinite: true,
    autoplay: true,
    speed: 1500,
    dots: true,
    fade: true,
  });
  $('.continent-slider').slick({
    dots: false,
    infinite: false,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: $('#continent-next'),
    prevArrow: $('#continent-prev'),
    responsive: [
      { breakpoint: 1440, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });
  $('#destination .fade-slider-5').slick({
    dots: false,
    infinite: false,
    speed: 400,
    arrows: true,
    centerPadding: '13rem',
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: $('.destination-next'),
    prevArrow: $('.destinantion-prev'),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  });
  $('#voyage .fade-slider-4').slick({
    speed: 400,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    centerPadding: '13rem',
    nextArrow: $('.voyage-next'),
    prevArrow: $('.voyage-prev'),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  });
  $('#activite .fade-slider-5').slick({
    speed: 400,
    dots: false,
    arrows: true,
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    centerPadding: '13rem',
    nextArrow: $('.activite-next'),
    prevArrow: $('.activite-prev'),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  });
  $('.slide-actualite .fade-slider-5').slick({
    speed: 400,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: '13rem',
    nextArrow: $('.actualite-next'),
    prevArrow: $('.actualite-prev'),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  });
  $('#voyageur .fade-slider-4').slick({
    speed: 400,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    centerPadding: '13rem',
    nextArrow: $('.voyageur-next'),
    prevArrow: $('.voyageur-prev'),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  });
  $('.slide-actualite').slick({
    dots: false,
    speed: 400,
    arrows: true,
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    nextArrow: $('#actu-next'),
    prevArrow: $('#actu-prev'),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  });
  $('.slide-parlent').slick({
    speed: 400,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3, infinite: true } },
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  });
  $('.slideEtape').slick({
    prevArrow: $('#etape-prev'),
    nextArrow: $('#etape-next'),
    draggable: false,
    infinite: false,
    arrows: true,
    dots: false,
    speed: 400,
  });
  $('.etape-slider').slick({
    centerPadding: '13rem',
    slidesToShow: 2,
    infinite: false,
    arrows: true,
    dots: false,
    speed: 400,
  });
  $('.merveille-slider').slick({
    speed: 400,
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    nextArrow: $('#merveil-next'),
    prevArrow: $('#merveil-prev'),
    responsive: [ { breakpoint: 1190, settings: { centerMode: true, slidesToShow: 1, variableWidth: true } } ],
  });
  $('.small-banner').slick({
    speed: 400,
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    nextArrow: $('#banner-next'),
    prevArrow: $('#banner-prev'),
    responsive: [ { breakpoint: 500, settings: { slidesToShow: 1, variableWidth: true, adaptiveHeight: true } } ],
  });

  const fondSlider = $('.fond-slider');
  if(fondSlider.find('.bg').length > 0) {
    fondSlider.slick({
      dots: false,
      infinite: true,
      autoplay: true,
      fade: true,
      speed: 1500,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
      mobileFirst: false,
      responsive: [ { breakpoint: 1200, settings: { dots: true, arrows:false } }],
    });
  }
}
